import { useState } from 'react'

import { IconClose } from './../../icons/close'
import { texts } from '../../locale'
import { ScrollableContent } from '../../scrollable-content'
import { Icon1 } from './icons/icon1'
import { Icon2 } from './icons/icon2'
import { Icon3 } from './icons/icon3'
import { Icon4 } from './icons/icon4'
import {
  IconsContainer,
  Icon,
  Title,
  Description,
  Label,
  PopupIcon,
  PopupText,
  PopupClose,
  IconCont1,
  IconCont2,
  IconCont3,
  IconCont4,
  Popup,
  Container,
} from './styled'

const ScreenIcons = () => {
  const iconsTitles = [
    texts.icons_3,
    texts.icons_4,
    texts.icons_5,
    texts.icons_6,
  ]
  const iconsTexts = [
    texts.icons_7,
    texts.icons_8,
    texts.icons_9,
    texts.icons_10,
  ]
  const [whichPopup, setWhichPopup] = useState(0)

  return (
    <div>
      <Title>{texts.icons_1}</Title>
      <Container>
        {whichPopup === 0 ? (
          <>
            <Description>{texts.icons_2}</Description>
            <IconsContainer>
              <Icon onClick={() => setWhichPopup(1)}>
                <Icon1 />
                <Label>{texts.icons_3}</Label>
              </Icon>
              <Icon onClick={() => setWhichPopup(2)}>
                <Icon2 />
                <Label>{texts.icons_4}</Label>
              </Icon>
              <Icon onClick={() => setWhichPopup(3)}>
                <Icon3 />
                <Label>{texts.icons_5}</Label>
              </Icon>
              <Icon onClick={() => setWhichPopup(4)}>
                <Icon4 />
                <Label>{texts.icons_6}</Label>
              </Icon>
            </IconsContainer>
          </>
        ) : (
          <Popup>
            {/* {whichPopup === 1 && (
              <PopupIcon>
                <IconCont1>
                  <Icon1 />
                </IconCont1>
              </PopupIcon>
            )}
            {whichPopup === 2 && (
              <PopupIcon>
                <IconCont2>
                  <Icon2 />
                </IconCont2>
              </PopupIcon>
            )}
            {whichPopup === 3 && (
              <PopupIcon>
                <IconCont3>
                  <Icon3 />
                </IconCont3>
              </PopupIcon>
            )}
            {whichPopup === 4 && (
              <PopupIcon>
                <IconCont4>
                  <Icon4 />
                </IconCont4>
              </PopupIcon>
            )} */}
            <PopupText>
              <h4>{iconsTitles[whichPopup - 1]}</h4>
              {iconsTexts[whichPopup - 1]}
            </PopupText>
            <PopupClose onClick={() => setWhichPopup(0)}>
              <IconClose />
            </PopupClose>
          </Popup>
        )}
      </Container>
    </div>
  )
}
export default ScreenIcons
